export default "__VITE_ASSET__ed2917f2__"